<template>
    <div class="orders">
        <el-row class="order-title">
            <el-col :span="3">
                <span class="h3">异常告警</span>
            </el-col>

        </el-row>

        <div class="order-data-list">
            <el-table :data="alarms">
                <el-table-column label="告警名称" align="center" prop="name" min-width="200"></el-table-column>
                <!--<el-table-column :label="$t('she_bei_bian_hao')" align="center" prop="deviceUuid" min-width="120"></el-table-column>-->
                <el-table-column :label="$t('she_bei_bian_hao')" align="center" prop="deviceUuid"></el-table-column>
                <el-table-column label="状态" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.status | filterStatus}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="发生时间" align="center" min-width="120">
                    <template slot-scope="scope">
                        <span>{{new Date(scope.row.createdAt * 1000).Format('yyyy-MM-dd hh:mm:ss')}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                @current-change="handleCurrentChange"
                class="pagination"
                :current-page="pagination.curPage"
                :page-size="pagination.limit"
                layout="total, prev, pager, next, jumper"
                :total="pagination.total">
        </el-pagination>
    </div>

</template>

<script>
    import {faultAlarmUnion, faultAlarmList} from '@/api/factory/research/fault'
    export default {
        name: '',
        components: {},
        activated: function () {
            this.loadAlarm()
        },
        data: function () {
            return {
                alarms: [],
                pagination: {
                    total: 0,
                    current: 0,
                    start: 0,
                    limit: 10,
                },
            }
        },
        filters: {

            filterStatus(status) {
                switch (status) {
                    case '0':
                        return '恢复正常'
                    case '1':
                        return '发生异常'
                }
            },

        },
        methods: {
            handleCurrentChange(value){
                this.pagination.curPage = value
                this.pagination.start = (value - 1) * this.pagination.limit
                faultAlarmList(this.pagination).then(res => {
                    this.alarms = res.data || []
                })
            },
            loadAlarm(){
                let vue = this
                this.pagination.curPage = 1
                this.pagination.start = 0
                faultAlarmUnion(this.pagination).then(res => {
                    vue.alarms = res.data.list || []
                    vue.pagination.total = parseInt(res.data.total)
                })
            },


        },
    }
</script>

<style lang="scss">
    .orders {
        padding: $padding $t-padding;
        display: flex;
        flex-direction: column;
        .order-title {
            .order-input-filter {
                input {
                    border: none;
                    border-bottom: 1px solid $f_fiv_color;
                    font-size: $filter-font-size;
                    border-radius: 0;
                }
            }
        }
        .order-data-list {
            margin-top: $padding;
            flex: 1;

            .order-info {
                .order-info-img {
                }
                .order-info-detail {

                    p {
                        margin-bottom: $padding-5;
                    }
                    p:first-child {
                        font-size: .8rem;
                    }
                }
            }

            .el-table {
                thead {
                    tr {
                        th {
                            border-bottom: 1px solid $border_sec_color;
                        }
                    }
                }

            }
            .el-table--group::after, .el-table--border::after, .el-table::before {
                background-color: transparent;
            }
            .el-table__row:hover {
                background-color: $bg_sec_color;
            }

            .order {
                padding: 0 .3rem;
            }
            .order-edit, .order-delete {
                cursor: pointer;
                display: inline-block;
            }
            .order-edit:hover, .order-delete:hover {
                color: $f_color;
            }
            .order-edit {
                color: $btn_color;
            }
            .order-edit:hover {
            }

            .order-delete {
                color: $btn_sec_color;
            }

            .order-delete:hover {
            }

            .disable {
                cursor: not-allowed;
                color: $f_50_color;
                border: none;
            }
            .disable:hover {
                color: $f_50_color;
                background-color: $bg_six_color;
            }

            .circle {
                border-radius: $small_font_size;
                width: $small_font_size;
                height: $small_font_size;
                display: inline-block;
                margin-right: 5px;
            }

            .wechatPay {
                color: #44b549;
            }

            .aliPay {
                color: #00aaee;
            }

            .testPayMake {
                color: #5AD8A6;
            }

            .notPayMake {
                color: #F6BD16;
            }

            .payMake {
                color: #5B8FF9;
            }

            .offline {
                color: #5B8FF9;
                .circle {
                    background-color: #5B8FF9;
                }
            }
            .normal {
                color: #5AD8A6;
                .circle {
                    background-color: #5AD8A6;
                }
            }

            .warning {
                color: #F6BD16;
                .circle {
                    background-color: #F6BD16;
                }
            }

            .fault {
                color: #E8684A;
                .circle {
                    background-color: #E8684A;
                }
            }

        }

        .pagination {
            margin: $padding;
            text-align: right;
        }
    }

</style>
